import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {connect} from 'react-redux'
import {withRouter} from 'react-router-dom'
import {logout, syncTokenWithLegacy} from 'mb-app-common/store/actions/auth'

export class Token extends Component{
	static propTypes = {
		dispatch: PropTypes.func.isRequired,
		token: PropTypes.object,
		history: PropTypes.shape({
			push: PropTypes.func.isRequired
		}).isRequired
	};

	componentWillReceiveProps(nextProps){
		if(!nextProps.token){
			this.props.dispatch(logout())
				.then(() => this.props.history.push('/login'))
		}else{
			this.props.dispatch(syncTokenWithLegacy(nextProps.token.accessToken))
				.catch(() => this.props.dispatch(logout()))
		}
	}

	render(){
		return (
			<div>
				<p>{this.props.token && this.props.token.refreshToken}</p>
			</div>
		)
	}
}

export default withRouter(connect((state) => {
	return {
		token: state.Auth.token
	}
})(Token))



// WEBPACK FOOTER //
// ./client/components/Token/index.js